import styled from 'styled-components';
import { Link } from 'react-router-dom';

interface ContainerProps {
	itemState: 'default' | 'deleting';
}

export const Container = styled.div<ContainerProps>`
	display: flex;
	width: 100%;
	margin-bottom: 20px;
	opacity: ${props => (props.itemState === 'deleting' ? '0.5' : '1')};
`;

export const Preview = styled.div`
	width: 320px;
	padding: 25px;
	border: 2px solid #1d1d1d;
	border-radius: 5px;
	background-color: #fff;
	text-align: center;
`;

export const DialogHeader = styled.h4`
	margin: 0 0 1em;
	font-weight: 500;
	font-size: 1rem;
`;

export const Amounts = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

export const Amount = styled.div`
	min-width: 42px;
	padding: 12px 15px;
	border: 2px solid #1d1d1d;
	border-radius: 5px;
	font-size: 0.75rem;
	font-weight: 500;
`;

export const Info = styled.div`
	display: flex;
	flex-flow: column;
	justify-content: center;
	margin-left: 30px;
`;

export const Title = styled.div`
	display: flex;
	align-items: center;
	margin-bottom: 15px;
	font-weight: 500;
	font-size: 1.3rem;
	user-select: none;
`;

export const Type = styled.span`
	display: inline-block;
	margin-left: 10px;
	padding: 3px 10px;
	border-radius: 6px;
	font-size: 0.75rem;
	background-color: rgba(0, 0, 0, 0.1);
	text-transform: capitalize;
`;

export const Time = styled.div`
	margin-bottom: 15px;
	font-size: 0.85rem;
	color: rgba(0, 0, 0, 0.5);
`;

export const Buttons = styled.div`
	display: flex;
`;

const ButtonStyles = `
	cursor: pointer;
	font-weight: 700;
	font-size: 0.85rem;
	color: #1d1d1d;
	text-transform: uppercase;
	text-decoration: underline;
	&:after {
		display: inline-block;
		content: '|';
		margin: 0 4px;
		color: rgba(0, 0, 0, .5);
	}
	&:last-child:after {
		content: '';
	}
`;

export const BasicLink = styled.a`
	${ButtonStyles};
`;

export const RouterLink = styled(Link)`
	${ButtonStyles};
`;
